//
// Cart
//

import CartManager from './cart-manager'
import { easepick } from '@easepick/core'
import { AmpPlugin } from '@easepick/amp-plugin'

;(($) => {
    $(() => {
        let module = $('.shopping-cart-wrapper')

        // Only continue if module is on page
        if (!module.length) return
        const cartExpandQuoteButton = $("form[name='coreshop_cart']").find('.expand-quote')
        const cartSummaryBlock = $('.cart-refresh-summary-block')
        const quoteFormWrapper = $('.cart-quote-form-wrapper')
        const quoteFormBackButton = quoteFormWrapper.find('button.back')
        const cartBody = module.find('.cart-body-wrapper')
        const totalSaving = module.find('.cart-summary-info-wrapper').find('.cart-total-saving .value')
        const totalPrice = module.find('.cart-summary-info-wrapper').find('.cart-total .value')
        const checkoutButton = module.find('.cart-buttons .checkout')
        const spinnerContainer = module.find('.cart-spinner-container')
        let erpIndividualPricesInt = null
        const locale = document.documentElement.lang || 'en'
        const isOneItemRental = document.getElementById('isOneItemRental')?.value
        const startDateInput = document.getElementById('quote_form_business_logged_in_fields_customerRentalStartDate')
        const endDateInput = document.getElementById('quote_form_business_logged_in_fields_customerRentalEndDate')
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const errorSpan = document.createElement('span');
        errorSpan.className = 'error-message';
        const errorSpanEnd = document.createElement('span');
        errorSpanEnd.className = 'error-message';

        if (isOneItemRental === 'false') {
            if (startDateInput != null && endDateInput != null) {
                startDateInput.parentElement.style.setProperty('display', 'none', 'important');
                endDateInput.parentElement.style.setProperty('display', 'none', 'important');
        
                startDateInput.removeAttribute('required')
                endDateInput.removeAttribute('required')
            }
          }
        const commonOptions = {
            css: [
                'https://cdn.jsdelivr.net/npm/@easepick/core@1.2.0/dist/index.css',
                '/',
            ],
            AmpPlugin: {
                dropdown: {
                    months: true,
                    years: true,
                },
                resetButton: true,
                darkMode: false,
            },
            zIndex: 9999,
            lang: document.querySelector('html')?.getAttribute('data-locale')?.replace('_', '-') || 'en',
            plugins: [AmpPlugin],
        }

        function parseDateFromDDMMYYYY(str) {
            const [day, month, year] = str.split('/');
            const parsedDate = new Date(year, month - 1, day);
            return isNaN(parsedDate.getTime()) ? null : parsedDate;
        }

        function blockAllManualInput(field) {
            field.addEventListener('keydown', e => e.preventDefault());
            field.addEventListener('paste', e => e.preventDefault());
            field.addEventListener('drop', e => e.preventDefault());
        }
    
        if (startDateInput != null) {
            // Create separate datepicker for Start Date
            const startDatePicker = new easepick.create({
                ...commonOptions,
                element: startDateInput,
                setup(picker) {
                    picker.on('select', () => {
                        const selectedDate = picker.getDate();

                        // Remove existing error if any
                        const existingStartError = startDateInput.parentNode.querySelector('.error-message');
                        if (existingStartError) existingStartError.remove();
            
                        // Check if it's before today
                        if (selectedDate < today) {
                            errorSpan.textContent = `${window.globals.trans('cart.quote.rental_start_date_error')}`;
                            errorSpan.style.display = 'inline-block';
                            startDateInput.parentNode.insertBefore(errorSpan, startDateInput.nextSibling);
                            startDateInput.value = '';
                            endDateInput.value = '';
                            return;
                        }

                        // Format and display date as dd/mm/yyyy
                        const day = String(selectedDate.getDate()).padStart(2, '0');
                        const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
                        const year = selectedDate.getFullYear();
                        startDateInput.value = `${day}/${month}/${year}`;
                    });
                }, 
            })
            startDateInput.classList.add('calendar-icon');
            startDateInput.removeAttribute('readonly')
            blockAllManualInput(startDateInput)
        }

        // Create separate datepicker for End Date
        if (endDateInput != null) {
            const endDatePicker = new easepick.create({
                ...commonOptions,
                element: endDateInput,
                setup(picker) {
                    picker.on('select', () => {
                        const selectedEndDate = picker.getDate();
                        const start = parseDateFromDDMMYYYY(startDateInput.value);
                        start.setHours(0, 0, 0, 0);
                        if (picker.getDate() < start || start == 'Invalid Date') {
                            endDateInput.parentNode.insertBefore(errorSpanEnd, endDateInput.nextSibling);
                            errorSpanEnd.textContent = `${window.globals.trans('cart.quote.rental_end_date_error')}`;
                            errorSpanEnd.style.display = 'inline-block';
                            endDateInput.value = '';
                            return false
                        } else {
                            const existingEndError = endDateInput.parentNode.querySelector('.error-message');
                            if (existingEndError) existingEndError.remove();
                        }

                        // Format and display date as dd/mm/yyyy
                        const day = String(selectedEndDate.getDate()).padStart(2, '0');
                        const month = String(selectedEndDate.getMonth() + 1).padStart(2, '0');
                        const year = selectedEndDate.getFullYear();
                        endDateInput.value = `${day}/${month}/${year}`;
                    })
                },
            })
            endDateInput.removeAttribute('readonly')
            endDateInput.classList.add('calendar-icon');
            blockAllManualInput(endDateInput)
        }

        cartExpandQuoteButton.on('click', (e) => {
            quoteFormWrapper.addClass('expanded')
            cartSummaryBlock.addClass('collapsed')
            $(e.currentTarget).attr('aria-expanded', 'true')
            quoteFormBackButton.attr('aria-expanded', 'true')
        })

        quoteFormBackButton.on('click', (e) => {
            quoteFormWrapper.removeClass('expanded')
            cartSummaryBlock.removeClass('collapsed')
            $(e.currentTarget).attr('aria-expanded', 'false')
            cartExpandQuoteButton.attr('aria-expanded', 'false')
        })

        $('.cart-quote-form-wrapper')
            .find('#quote_form_business_logged_in')
            .on('submit', function (e) {
               console.log('start ---- cart-coreshop.js');
               console.log(new Date().toISOString(),166+'cart-coreshop.js');
               
                e.preventDefault()
                
                
                /* If cart has at least one rental product */
                if (isOneItemRental === 'true') {
                    console.log(new Date().toISOString(),169+'cart-coreshop.js');
                    // remove any previous errors safely
                    if (startDateInput) {
                        const existingStartError = startDateInput.parentNode.querySelector('.error-message');
                        if (existingStartError) existingStartError.remove();
                    }
                    if (endDateInput) {
                        const existingEndError = endDateInput.parentNode.querySelector('.error-message');
                        if (existingEndError) existingEndError.remove();
                    }
                    console.log(new Date().toISOString(),179+'cart-coreshop.js');
                    // --- START DATE CHECK ---
                    if (startDateInput) {
                        console.log(new Date().toISOString(),182+'cart-coreshop.js');
                        const rawStart = startDateInput.value?.trim() ?? '';
                        const startDate = parseDateFromDDMMYYYY(rawStart);
                        console.log(new Date().toISOString(),185+'cart-coreshop.js');
                        // ensure it's a real Date
                        if (!(startDate instanceof Date) || isNaN(startDate.getTime())) {
                            console.log(new Date().toISOString(),188+'cart-coreshop.js');
                            errorSpan.textContent = window.globals.trans('cart.quote.invalid_date');
                            errorSpan.style.display = 'inline-block';
                            startDateInput.parentNode.insertBefore(errorSpan, startDateInput.nextSibling);
                            startDateInput.value = '';
                            if (endDateInput) endDateInput.value = '';
                            return false;
                        }
                    }
                    console.log(new Date().toISOString(),197+'cart-coreshop.js');
                    // --- END DATE CHECK ---
                    if (endDateInput) {
                        console.log(new Date().toISOString(),200+'cart-coreshop.js');
                        const rawEnd = endDateInput.value?.trim() ?? '';
                        const endDate = parseDateFromDDMMYYYY(rawEnd);
                        console.log(new Date().toISOString(),203+'cart-coreshop.js');
                        if (!(endDate instanceof Date) || isNaN(endDate.getTime())) {
                            console.log(new Date().toISOString(),205+'cart-coreshop.js');
                            errorSpanEnd.textContent = window.globals.trans('cart.quote.invalid_date');
                            errorSpanEnd.style.display = 'inline-block';
                            endDateInput.parentNode.insertBefore(errorSpanEnd, endDateInput.nextSibling);
                            endDateInput.value = '';
                            return false;
                        }
                    }
                    console.log(new Date().toISOString(),213+'cart-coreshop.js');
                    // --- BOTH START & END DATE CHECKS ---
                    if (startDateInput && endDateInput) {
                        console.log(new Date().toISOString(),216+'cart-coreshop.js');
                        const rawStart = startDateInput.value?.trim() ?? '';
                        const rawEnd = endDateInput.value?.trim() ?? '';
                        const startDate = parseDateFromDDMMYYYY(rawStart);
                        const endDate = parseDateFromDDMMYYYY(rawEnd);
                        console.log(new Date().toISOString(),221+'cart-coreshop.js');
                        // extra guard
                        if (!(startDate instanceof Date) || isNaN(startDate.getTime()) ||
                            !(endDate instanceof Date) || isNaN(endDate.getTime())) {
                            // one of the dates invalid, bail out
                            return false;
                        }

                        if (startDate < today) {
                            errorSpan.textContent = window.globals.trans('cart.quote.rental_start_date_error');
                            errorSpan.style.display = 'inline-block';
                            startDateInput.parentNode.insertBefore(errorSpan, startDateInput.nextSibling);
                            startDateInput.value = '';
                            endDateInput.value = '';
                            return false;
                        }

                        if (startDate > endDate) {
                            errorSpanEnd.textContent = window.globals.trans('cart.quote.rental_end_date_error');
                            errorSpanEnd.style.display = 'inline-block';
                            endDateInput.parentNode.insertBefore(errorSpanEnd, endDateInput.nextSibling);
                            endDateInput.value = '';
                            return false;
                        }
                    }
                }
                console.log(new Date().toISOString(),247+'cart-coreshop.js');
                /* Apply check to fix issue LISXGPIM-211 */
                $(this).find("button[type='submit']").attr("disabled", true);
                var oneTimeQuoteSubmit = $('#oneTimeQuoteSubmit');
                console.log(new Date().toISOString(),252+'cart-coreshop.js');
                if (!oneTimeQuoteSubmit.val()) {
                    console.log(new Date().toISOString(),254+'cart-coreshop.js');
                    var flagInput = $('<input>', {
                        type: 'hidden',
                        id: 'oneTimeQuoteSubmit',
                        name: 'oneTimeQuoteSubmit',
                        value: '1'
                    });
                    console.log(new Date().toISOString(),261+'cart-coreshop.js');
                    
                    $('#quote_form_business_logged_in').append(flagInput);
                } else {
                    console.log(new Date().toISOString(),265+'cart-coreshop.js');
                    $('#oneTimeQuoteSubmit').val('');
                }
                console.log(new Date().toISOString(),268+'cart-coreshop.js');
                window.grecaptcha.reset();
                window.grecaptcha.execute();
                console.log('end ---- cart-coreshop.js');
                
            })

        checkoutButton.on('click', function () {
            if ($(this).hasClass('disabled')) {
                return false
            }
        })

        const certificateCheckboxes = module.find('.item-certificate')
        certificateCheckboxes.change(function () {
            let itemId = $(this).attr('data-item-id')
            CartManager.updateItemCertificate(itemId, $(this).is(':checked'))
        })

        if (spinnerContainer.length) {
            erpIndividualPricesInt = setInterval(() => {
                queryAndRefreshIndividualPrices(erpIndividualPricesInt)
            }, 4000)

            queryAndRefreshIndividualPrices(erpIndividualPricesInt)
        }

        function refreshPricesAndUnlockCart(data) {
            // cart items
            cartBody.find('.cart-item-row').each(function () {
                let item = $(this)
                let itemData = data[item.attr('id')]
                if (itemData) {
                    item.find('.discount').find('.value').text(itemData.discount)
                    item.find('.subtotal').find('.value').text(itemData.subtotal)
                }
            })

            // total saving
            totalSaving.text(data.cartDiscount)

            // total price
            totalPrice.text(data.total)

            // hide spinner
            spinnerContainer.hide()

            // unlock checkout button
            checkoutButton.removeClass('disabled')
        }

        function queryAndRefreshIndividualPrices(interval = null) {
            if ($('.autoDiscount').length > 0) {
                $('.autoDiscount').text('');
                $('.auto-discount-saving').text('');
            }

            $.ajax({
                type: 'GET',
                url: `/${locale}/shop/cart/price`,
                cache: false,
                success: (data) => {
                    if (Object.keys(data).length) {
                        if (interval) clearInterval(interval)
                        refreshCartAutoDiscountPriceWithERPPrices();
                        refreshPricesAndUnlockCart(data)
                    }
                },
                error: () => {
                    console.log('Error while fetching cart individual prices.')
                },
            })
        }

        function refreshCartAutoDiscountPriceWithERPPrices() {
            $.ajax({
                type: 'GET',
                url: `/${locale}/shop/cart/auto-discount-prices`,
                cache: false,
                success: (res) => {
                    for (let key in res.autoDiscount) {
                        if (res.autoDiscount.hasOwnProperty(key)) {
                            const value = res.autoDiscount[key];
                            const elements = document.getElementsByClassName(key);

                            if (elements.length > 0) {
                                Array.from(elements).forEach(el => {
                                    el.innerText = value;
                                });
                            } else {
                                console.warn(`No elements found for class: ${key}`);
                            }
                        }
                    }

                    if (res.totalAutoSaving != 0) {
                        document.getElementsByClassName('auto-discount-saving')[0].innerText = res.totalAutoSaving;
                    }

                    // total price
                    if (res.orderTotal != 0) {
                        totalPrice.text(res.orderTotal)
                    }
                }
            })
        }

       

        // /* ================================
        // * Quantity input (+ / -) handling
        // * ================================ */

        const QTY_SELECTOR = '.core-shop-input-quantity';

        function getOrStoreSeparator(input, val) {
            let sep = input.data('separator');

            if (!sep) {
                sep = String(val).includes(',') ? ',' : '.';
                input.data('separator', sep);
            }

            return sep;
        }

        function parseQty(val) {
            if (val == null) return NaN;
            const num = Number(String(val).replace(',', '.'));
            return isNaN(num) ? NaN : num;
        }

        function formatQty(val, precision, separator) {
            let str;

            if (precision === 0) {
                str = Math.round(val).toString();
            } else {
                str = val.toFixed(precision);

                // remove trailing zeros
                str = str.replace(/\.?0+$/, '');
            }

            // restore comma separator if needed
            if (separator === ',') {
                str = str.replace('.', ',');
            }

            return str;
        }


        function getLimits(input) {
            return {
                min: input.attr('min') !== undefined ? Number(input.attr('min')) : 0,
                max: input.attr('max') !== undefined ? Number(input.attr('max')) : Infinity
            };
        }

        function getStep(input) {
            const precision = parseInt(input.data('cs-unit-precision')) || 0;
            return precision > 0 ? Math.pow(10, -precision) : 1;
        }

        /* ================================
        * ALLOW ONLY NUMBERS / DOT / COMMA
        * ================================ */

        module.on('input', QTY_SELECTOR, function () {
            let val = this.value.replace(/[^0-9.,]/g, '');

            // allow only one separator
            const match = val.match(/[.,]/);
            if (match) {
                const sep = match[0];
                const parts = val.split(/[.,]/);
                val = parts[0] + sep + parts.slice(1).join('');
                $(this).data('separator', sep);
            }

            this.value = val;
        });

        /* ================================
        * CORE QUANTITY CHANGE
        * ================================ */

        function changeQty(input, direction) {
            const precision = parseInt(input.data('cs-unit-precision')) || 0;
            const step = getStep(input);
            const limits = getLimits(input);

            const raw = input.val();
            const separator = getOrStoreSeparator(input, raw);

            let value = parseQty(raw);
            if (isNaN(value)) value = limits.min;

            value += direction * step;
            value = Math.min(limits.max, Math.max(limits.min, value));

            input
                .val(formatQty(value, precision, separator))
                .trigger('change');
        }

        /* ================================
        * NORMALIZE ON BLUR / CHANGE
        * ================================ */

        module.on('blur change', QTY_SELECTOR, function () {
            const input = $(this);
            const precision = parseInt(input.data('cs-unit-precision')) || 0;
            const limits = getLimits(input);

            const raw = this.value;
            const separator = getOrStoreSeparator(input, raw);

            let value = parseQty(raw);
            if (isNaN(value)) value = limits.min;

            value = Math.min(limits.max, Math.max(limits.min, value));
            this.value = formatQty(value, precision, separator);
        });

        /* ================================
        * HOLD + / -
        * ================================ */

        let holdInterval = null;

        module.on('mousedown touchstart', '.button-increase, .button-decrease', function (e) {
            e.preventDefault();

            const btn = $(this);
            const input = btn.siblings(QTY_SELECTOR);
            if (!input.length) return;

            const direction = btn.hasClass('button-increase') ? 1 : -1;

            changeQty(input, direction);

            holdInterval = setInterval(() => {
                changeQty(input, direction);
            }, 150);
        });

        $(document).on('mouseup touchend', () => {
            clearInterval(holdInterval);
            holdInterval = null;
        });

        /* ================================
        * KEYBOARD ↑ ↓
        * ================================ */

        module.on('keydown', QTY_SELECTOR, function (e) {
            if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;

            e.preventDefault();
            changeQty($(this), e.key === 'ArrowUp' ? 1 : -1);
        });

        /* ================================
        * MOUSE WHEEL
        * ================================ */

        module.on('wheel', QTY_SELECTOR, function (e) {
            e.preventDefault();
            changeQty($(this), e.originalEvent.deltaY < 0 ? 1 : -1);
        });
    })
})(jQuery)
